export default __webpack_public_path__ + "static/media/play-circle.196e9f5c.svg";